export const PASSWORD_PATTERN = /^[0-9]{8}$/;

export default {
  methods: {
    $passwordValidator(rule, value, callback) {
      if (value === '') {
        callback(new Error('CAN_NOT_BE_EMPTY'));
      } if (!value.match(PASSWORD_PATTERN)) {
        callback(new Error('PATTERN_DOES_NOT_MACTH'));
      } else {
        callback();
      }
    },
    $passwordConfirmValidator(rule, value, callback) {
      if (value === '') {
        callback(new Error('CAN_NOT_BE_EMPTY'));
      } if (value !== this.form.password) {
        callback(new Error('CONFIRM_DOES_NOT_MATCH_PASSWORD'));
      } else {
        callback();
      }
    },
  },
};
